export default () => ({
    location: '',
    lat: null,
    lng: null,
});
